import { Component, OnInit,Input,ViewChild } from '@angular/core';
//import { AgmInfoWindow } from "@agm/core";
import { trailService } from 'src/app/services/trail.service';
import {MapInfoWindow, MapMarker, GoogleMap} from '@angular/google-maps';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
@Component({
  selector: 'app-agm-map',
  templateUrl: './agm-map.component.html',
  styleUrls: ['./agm-map.component.scss']
})
export class AgmMapComponent implements OnInit {
  @Input() User:any;
  @Input() trailData:any;
  @Input() mapType:any;
  @Input() weekType:any;
  @Input() laycanStart:any;
  @Input() laycanEnd:any;
  @Input() centerLat:any;
  @Input() centerLong:any;
  lat = 20.704060;
  long = 70.102493;
  googleMapType = 'satellite';
  locIcon = "assets/images/map-marker.png";
  locIconCurrent = "assets/images/map-arrow.png";
  mapDot = "assets/images/map-dot.png";
  portDot= "assets/images/port-dot.png";
  markDot= "assets/images/load-discharge-port.png";
  currentShipIcon = 'assets/images/svg/Vessel-location.svg';
  passingPort ="assets/images/svg/Passing-Port.svg";
  wordMapRestriction ={ latLngBounds : {north: 83.8, south: -57, west: -180, east: 180}};
  styles: /*MapTypeStyle[] |*/ any[];
  stylesMap:any[];
  currentIW: any;
  previousIW: any;

  mapView = false;
  showModal = false;
  //trailData = [];
  metaData = [];
  filterData = [];
  exampleModalVar = '';
  lng = -95.060537;
  markerLat;
  markerLong;
  mapTrail = [];
  heading = 0;
  last_position_update:any;
  lineSymbol  = {
    path: "M 0,-1 0,1",
    strokeOpacity: 100,
    scale: 2,
  };
  options: google.maps.MapOptions;
  optionsMap: google.maps.MapOptions;
  markerCluster?: MarkerClusterer
  markerClustererImagePath =
      'assets/images/circle-layer';
  polygonArr : any = [];
  otherRegionProbabilityData = [];
  @ViewChild(MapInfoWindow,{ static: false }) infoWindow: MapInfoWindow;
  @ViewChild('googleMap', { static: true }) googleMap: GoogleMap;
  @ViewChild('mapMarker', { static: false }) mapMarker: any[];
  onMouseOver(infoWindow, $event: MouseEvent) {
    infoWindow.open();
  }
  onMouseOut(infoWindow, $event: MouseEvent) {
    infoWindow.close();
  }
  mapClick(){
      if (this.previousIW) {
        this.previousIW.close();
      }
  }
  openInfoWindow(marker: MapMarker, infoWindow: MapInfoWindow) {
    infoWindow.open(marker);
  }
  markerClick(marker: MapMarker, $event,imo:any) {
    this.infoWindow.open(marker);
    this.onClickVesselDetails(imo);
    // if (this.previousIW) {
    //   this.currentIW = infoWindow;
    //   this.previousIW.close();
    // }
    // this.previousIW = infoWindow;
  }
  closeWindow(infoWindow: any,event){
    if (this.previousIW) {
      this.currentIW = infoWindow;
      this.previousIW.close();
    }
    this.previousIW = infoWindow;
  }
  onClickVesselDetails(imo:any = 0){
    (imo > 0) ? this.getVesselDetailsData(imo) : '';
  }
  getVesselDetailsData(imo:any){
    let queryParams = imo;
    this.metaData = [];
    this.trailService.fetchData(queryParams).subscribe(data => {
      setTimeout(() => {
        this.trailData = data.data;
        this.metaData = data.metaData;
        // port data arrival & departure
        for(let i=0; i<this.trailData?.length; i++){
          this.trailData[i]["arrivalTime"] = this.metaData['port_timings'][0][i].arrival_time;
          this.trailData[i]["departureTime"] = this.metaData['port_timings'][0][i].departure_time;
          this.trailData[i]["stop_port_UNlocode"] = this.metaData['port_timings'][0][i].stop_port_UNlocode;
          this.trailData[i]["stop_port_name"] = this.metaData['port_timings'][0][i].port_name;
          this.trailData[i]["draught"] = this.metaData['port_timings'][0][i].draft_at_arrival_calculated;
          this.trailData[i]["Latitude"] = this.metaData['port_timings'][0][i].latitude;
          this.trailData[i]["Longitude"] = this.metaData['port_timings'][0][i].longitude;
        }
        // calling map route api here
        this.trailService.fetchMapData(queryParams).subscribe(data => {
          /* this.mapTrail = data.data.filter((d)=>{
            let lengthTrail = this.trailData.length;
            let firstPortArrivalDate = this.trailData[0]['arrivalTime'];
            let lastPortDepartureDate = this.trailData[lengthTrail-1]['departureTime'];
            return d.timestamp >= firstPortArrivalDate && d.timestamp <= lastPortDepartureDate
          }); */
          this.mapTrail = data.data;
          //this.arVesselsLocation = locationHistory.map((it: LatLong) => ({ ...it, history: this.historyLatLong(it.history) }));
          this.mapTrail.sort((a,b)=>{
            return a.timestamp.localeCompare(b.timestamp)
          })
          this.last_position_update = this.mapTrail[this.mapTrail.length - 1]
          this.last_position_update = this.last_position_update.timestamp;
          /* console.log(this.last_position_update);
          let dd = this.last_position_update.timestamp;
          let day = new Date(dd).getDate();
          let month = new Date(dd).getMonth() + 1;
          let year = new Date(dd).getFullYear();
          let split = dd.split(" ")[1].split(":");
          let dateSplit = dd.split(" ")[0].split("-");
          let hrs = split[0];
          let mins = split[1];
          this.last_position_update = `${day}/${dateSplit[1]}/${year} ${hrs}:${mins}`; */
          //this.polygonArr = this.mapTrail.map((el)=> ({lat:parseFloat(el.latitude),lng:parseFloat(el.longitude)}))
          setTimeout(()=>{
            this.polygonArr = this.mapTrail.map((el)=> ({lat:parseFloat(el.latitude),lng:parseFloat(el.longitude)}))
            console.log("poly",this.polygonArr)
            console.log("map trail",this.mapTrail)
            let length = Math.round(this.mapTrail.length/2);
            this.optionsMap.center.lat = (this.mapTrail && this.mapTrail[length].latitude) ? this.mapTrail[length].latitude : this.lat ;
            this.optionsMap.center.lng = (this.mapTrail && this.mapTrail[length].longitude) ? this.mapTrail[length].longitude : this.lng ;
          },100)
          console.log("map trail",this.mapTrail)
        },err=>{
          console.log("trail map api error",err)
          this.mapTrail = [];
        })
      }, 1000);
    let filter = this.User.filter((m)=> m.imo == imo)
    this.filterData = filter[0];
    this.heading = this.filterData['heading'] + 110;
    console.log("filterdata",this.filterData)
    //console.log(this.filterData['heading']);
    //this.filterData['heading'] = Math.floor((this.filterData['heading'] / 22.5) + 0.5) % 16;
    //console.log(this.filterData['heading']);
    this.showModal = true;
    this.exampleModalVar = 'exampleModal';
    // other region probability api hit
    let otherQueryParams = {"from":this.laycanStart.toISOString(),"to":this.laycanEnd.toISOString(),"imo":imo};
    this.trailService.fetchOtherRegionProbabilityData(otherQueryParams).subscribe(data => {
      console.log("other region data",data)
      let result = data.data;

      this.otherRegionProbabilityData = result.filter((el)=>el.region != this.filterData['region']);
    },err=>{
      console.log("other region probability api error",err)
      this.otherRegionProbabilityData = []
    })
  },err=>{
    console.log("trail api error",err)
    this.showModal = false;
  })
  }
  historyLatLong = (data:any) => {
    return data.map((it:any) => ({ 'lat': parseFloat(it.latitude), 'lng': parseFloat(it.longitude) }));
  }
  bookingCommanStyle() {
    return [
      { 'elementType': "geometry", 'stylers': [{ 'color': "#373850" }] },
      {
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'elementType': "labels.text.fill",
        'stylers': [
          {
            'visibility': "off"
          }
        ]
      },
      {
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#16192C'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [{ 'visibility': 'off' }],
      },
    ];
  }
  bookingDetailStyle() {
    return  [
      { 'elementType': "geometry", 'stylers': [{ 'color': "#565656" }] },
    {
      "featureType": "administrative.country",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#353535"
        }
      ]
    },
    {
      'featureType': "administrative.country",
      'elementType': "labels",
      'stylers': [
          { 'color': '#D2D2D2' }
      ]
  },
    {
      "featureType": "administrative.country",
      'elementType': "labels.text.fill",
      'stylers': [
          { 'visibility': 'off' }
      ]
    },
    {
      "featureType": "administrative.country",
      'elementType': "labels.text.stroke",
      'stylers': [
        {
          'color': '#D2D2D2'
        }
      ]
    },
  
      {
        "featureType": "administrative.province",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "administrative.province",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "administrative.province",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
  
      {
        "featureType": "administrative.locality",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "administrative.locality",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
  
      {
        "featureType": "poi",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "poi",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "poi",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
  
      {
        "featureType": "road",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "road",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "road",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
  
      {
        "featureType": "transit",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "transit",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "transit",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      
      {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#353535'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [{ 'color': '#D2D2D2' }],
      },
    ];
  }
  constructor(private trailService:trailService) { }

  ngOnInit(): void {
    this.stylesMap = this.bookingDetailStyle();
    this.styles = this.bookingCommanStyle();
    this.optionsMap ={
      zoom: 4,
      minZoom: 2,
      styles: this.stylesMap,
      streetViewControl:false,
       center:{lat:this.lat,lng:this.long},
      }
      this.options ={
        zoom: 5,
        minZoom: 2,
        styles: this.styles,
        streetViewControl:false,
         center:{lat:this.centerLat,lng:this.centerLong},
        }
  }
  initClusterer(event:any) {
    if (!this.googleMap?.googleMap || this.markerCluster) return
    this.markerCluster = new MarkerClusterer({
      map: this.googleMap.googleMap,
      markers: this.mapMarker,
    })
}

}
